<script setup>
import { ref, inject } from 'vue';
import NotificationGroup from '@/components/block/notifications/NotificationGroup.vue';

const { closeNotifications } = inject('notifications')

const activeTab = ref(1);

const allNotifications = ref([
  { date: 'TODAY', status: true, time: '08:15', message: 'New fulfillment request from [insurance company] [shipping request page link]' },
  { date: 'TODAY', status: true, time: '08:15', message: '[shipping request page link] fulfillment request is [# days old] days old and has been 40% completed. Please fulfill ASAP!' },
  { date: 'TODAY', status: true, time: '08:15', message: 'Your claims report has finished compiling [link to report page].' },
  { date: 'YESTERDAY', status: false, time: '08:15', message: 'New Insurance Company [insurance company] has been added to Flood Alert.' },
  { date: 'YESTERDAY', status: false, time: '08:15', message: 'New Insurance Company [insurance company] has been added to Flood Alert.' },
]);

const unreadNotifications = ref([
  { date: 'TODAY', status: true, time: '08:15', message: 'New Insurance Company [insurance company] has been added to Flood Alert.' },
  { date: 'YESTERDAY', status: true, time: '08:15', message: 'New Insurance Company [insurance company] has been added to Flood Alert.' },
]);

function groupedNotifications(notifications) {
  const groups = {};

  notifications.forEach(notification => {
    if (!groups[notification.date]) {
      groups[notification.date] = [];
    }
    groups[notification.date].push(notification);
  });

  return Object.keys(groups).map(date => ({
    date,
    notifications: groups[date]
  }));
}
</script>


<template>
	<div class="notifications">
		<div class="notifications__header">
			<p>
				<span class="material-symbols-outlined">notifications</span>
				<b>Notifications</b>
			</p>
			<span class="material-symbols-outlined notifications__close" @click="closeNotifications">close</span>
		</div>

		<div class="notifications__tabs">
			<a href="#" @click.prevent="activeTab = 1" :class="{ notifications__tabs_active: activeTab === 1 }" class="notifications__tabs_link">All Notifications</a>
			<a href="#" @click.prevent="activeTab = 2" :class="{ notifications__tabs_active: activeTab === 2 }" class="notifications__tabs_link">Unread</a>
		</div>

		<div v-show="activeTab === 1" class="notifications__list notifications__all">
			<NotificationGroup
				v-for="(group, index) in groupedNotifications(allNotifications)"
				:key="index"
				:date="group.date"
				:notifications="group.notifications"
			/>
		</div>

		<div v-show="activeTab === 2" class="notifications__list notifications__unread">
			<NotificationGroup
				v-for="(group, index) in groupedNotifications(unreadNotifications)"
				:key="index"
				:date="group.date"
				:notifications="group.notifications"
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.notifications {
		position: fixed;
		top: 80px;
		right: -405px;
		width: 405px;
		height: 89vh;
		padding: 20px;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		background-color: #fff;
		box-shadow: -10px 0 10px rgba(0, 0, 0, 0.05);
		z-index: 102;
		transition: all .6s;
	}
	.notifications--active {
		right: 0;
	}
	.notifications__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}
	.notifications__header p {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}
	.notifications__header b {
		line-height: 1;
	}
	.notifications__close {
		cursor: pointer;
		transition: all .6s;
		&:hover {
			color: #2563EB;
			transform: scale(1.2);
		}
	}
	.notifications__tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding-top: 15px;
		padding-bottom: 20px;
	}
	.notifications__tabs_link {
		height: 32px;
		border-radius: 32px;
		font-size: 14px;
		color: #94a3b8;
		padding: 0 12px;
		line-height: 32px;
		background-color: #F1F5F9;
		transition: all .6s;
		text-decoration: none;
		cursor: pointer;
	}
	.notifications__tabs_active {
		color: #2563EB;
		background-color: #EFF6FF;
	}
	.notifications__list {
		display: flex;
		flex-direction: column;
		gap: 8px;
		height: calc(100% - 130px);
		padding-right: 8px;
		overflow: auto;
	}
</style>
